export const USER_AUTH_TICKET = 'USER_AUTH_TICKET';

export interface AuthState {
  loggedIn: boolean;
  token: string;
}

interface AuthTicketAction {
  type: typeof USER_AUTH_TICKET;
  token: string;
}

export type AuthActions = AuthTicketAction;
